export default function formatYAxisLabel(value, decimals = 0) {
    try {
        // normalizing the decimals input to a safe integer in the range 0–4 - else default to 0
        const numOfDecimals = Number.isFinite(decimals)
            ? Math.max(0, Math.min(4, Math.trunc(decimals)))
            : 0;

        const numberFormatter = new Intl.NumberFormat("da-DK", {
            minimumFractionDigits: numOfDecimals,
            maximumFractionDigits: numOfDecimals,
        });

        return numberFormatter.format(value);
    } catch (error) {
        console.warn("YAxis formatting failed:", error);
        return String(value ?? "");
    }
}